var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-page-container mobile-padding flex-centerize flex-column"},[_c('div',{staticClass:"mobile-title mb-3"},[_vm._v("Open in your device's native browser to continue.")]),_c('div',{staticClass:"gif-container"},[_c('img',{staticClass:"width-100 height-100",attrs:{"src":"/assets/gif/open-in-browser.gif"}})])])
}]

export { render, staticRenderFns }